import React from 'react';

import Box, { BoxProps } from '@mui/material/Box'
import Card from '@mui/material/Card'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import Grid, { GridProps } from '@mui/material/Grid';
import { styled, useTheme } from '@mui/material/styles'
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import Link from '@mui/material/Link';

import { useNavigate } from "react-router-dom";
import { Controller, useForm } from 'react-hook-form'


// Styled Grid component
const StyledGrid = styled(Grid)<GridProps>(({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
        order: -1,
        display: 'flex',
        justifyContent: 'center'
    }
}))

// Styled component for the image
const Img = styled('img')(({ theme }) => ({
    right: 0,
    bottom: 8,
    width: 100,
    position: 'absolute',
    [theme.breakpoints.down('sm')]: {
        width: 200,
        position: 'static'
    }
}))

const BoxWrapper = styled(Box)<BoxProps>(({ theme }) => ({
    [theme.breakpoints.down('md')]: {
        width: '90vw'
    }
}))

export default function Home() {

    const navigate = useNavigate();

    return (
        <Box className='content-center'>
            <Box sx={{ p: 5, display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                <BoxWrapper>
                    <Typography variant='h1' sx={{ mb: 2.5 }}>
                        404
                    </Typography>
                    <Typography variant='h5' sx={{ mb: 2.5, letterSpacing: '0.18px', fontSize: '1.5rem !important' }}>
                        Page Not Found ⚠️
                    </Typography>
                    <Typography variant='body2'>We couldn&prime;t find the page you are looking for.</Typography>
                </BoxWrapper>
                {/* <Button href='/home' component={Link} variant='outlined' sx={{ px: 5.5 }}>
                    Back to Home
                </Button> */}
            </Box>
        </Box>
    )
}
